import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import pt from 'vuetify/es5/locale/pt';

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { pt },
    current: 'pt',
  },
  icons: {
    iconfont: 'fa',
  },
  theme: {
    themes: {
      light: {
        primary: '#000066',
        secondary: '#fafbfb',
        accent: '#0399CC',
        success: '#4CAF50',
        info: '#2196F3',
        dark: '#141920',
        red: '#FF5252',
      },
    },
  },
});
